/**
 * @generated SignedSource<<ea6a9b9a107f9a69ede6d899b8921615>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type photoEssayArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleLandingBannerArticle" | "globalCheckerContent">;
  readonly " $fragmentType": "photoEssayArticleArticle";
};
export type photoEssayArticleArticle$key = {
  readonly " $data"?: photoEssayArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"photoEssayArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "photoEssayArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLandingBannerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "45784f40bea03bd3e8aa9aecec12627b";

export default node;
